import React from "react";
import ButtonPrimary from "../../buttons/ButtonPrimary";
import ButtonSecondary from "../../buttons/ButtonSecondary";

const PopupConfirmation = (props) => {
  const { message, onClickTrue, trueText, onClickFalse, falseText, className, isVisible, variant, topContainer } =
    props;

  return (
    <div
      className={`popup-confirmation ${isVisible ? "popup-confirmation-visible" : ""} ${variant} ${className}`}
      onClick={onClickFalse}
    >
      <div className="container" onClick={(e) => e.stopPropagation()}>
        {topContainer}
        <p className="message">{message}</p>
        <div className="flex">
          <ButtonPrimary variant="h-primary" text={falseText} onClick={onClickFalse} size="sm" className={`false`} />
          <ButtonSecondary text={trueText} onClick={onClickTrue} size="sm" className={`true`} />
        </div>
      </div>
    </div>
  );
};

export default PopupConfirmation;
